var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"max-w-md mx-auto grid grid-cols-7 gap-2"},_vm._l((_setup.calendarWeeks),function(day){return _c('div',{key:day.id,staticClass:"flex items-center justify-center font-medium text-sm w-9 h-7 py-1.5 px-2"},[_vm._v("\n    "+_vm._s(day.label)+"\n  ")])}),0)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }